export enum BidStatus {
  PENDING = 'pending',
  CONFIRMED = 'confirmed',
  NOT_APPROVED = 'not_approved',
  UNAVAILABLE = 'unavailable',
}
